import React, { useState, useEffect } from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import Icon from "../../../../components/Icon";
import Actions from "../../../../components/Actions";
import Modal from "../../../../components/Modal";
import Schedule from "../../../../components/Schedule";
import { useNavigate } from "react-router-dom";
import { getSessionFormationById } from "../../../../services/sessions.service";

const Row = ({ item, onDelete, onDuplicate }) => {
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState(new Date());
    const [startTime, setStartTime] = useState(new Date());
    const [visibleModalSchedule, setVisibleModalSchedule] = useState(false);

    const handleRowClick = async () => {
        try {
            // Récupérer les données complètes de la session avant de naviguer
            const sessionData = await getSessionFormationById(item.id);
            navigate(`/teacher/sessions-formation/${item.id}`, { state: { session: sessionData } });
        } catch (error) {
            console.error('Erreur lors de la récupération des données de la session:', error);
            // Naviguer quand même avec les données partielles
            navigate(`/teacher/sessions-formation/${item.id}`, { state: { session: item } });
        }
    };

    const handleDelete = () => {
        if (onDelete) {
            onDelete(item.id);
        }
    };

    const handleDuplicate = () => {
        if (onDuplicate) {
            onDuplicate(item.id);
        }
    };

    const actions = [
        {
            title: "Voir les détails",
            icon: "eye",
            action: handleRowClick,
        },
        {
            title: "Modifier la session",
            icon: "edit",
            action: () => console.log("Modifier la session"),
        },
        {
            title: "Dupliquer la session",
            icon: "copy",
            action: handleDuplicate,
        },
        {
            title: "Supprimer la session",
            icon: "trash",
            action: handleDelete,
        },
    ];

    return (
        <>
            <div className={styles.row} style={{ cursor: 'pointer' }}>
                <div className={styles.col}>
                   
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.item}>
                        <div className={styles.avatar}>
                            <img src={item.logoUrl || '/images/content/hour_logo.png'} alt="Logo" />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.product}>{item.title}</div>
                            <div className={styles.date}>
                                <Icon name="clock" size="20" /> {new Date(item.start_date).toLocaleDateString('fr-FR')}
                            </div>
                        </div>
                    </div>
                </div>
               

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.startDate}>
                        {new Date(item.start_date).toLocaleDateString('fr-FR')} à {new Date(item.start_date).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.endDate}>
                        {new Date(item.end_date).toLocaleDateString('fr-FR')} à {new Date(item.end_date).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.formation}>
                        {item.expand?.teacher_id ?
                            `${item.expand.teacher_id.first_name} ${item.expand.teacher_id.last_name}` :
                            'Formateur non défini'}
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.group}>
                        {item.expand?.session_id?.title || 'Groupe non défini'}
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={cn(
                        'status-type',
                        item.status === 'Ouvert' ? 'status-green-dark' :
                            item.status === 'Fermé' ? 'status-blue-dark' :
                                item.status === 'Prévu' ? 'status-yellow-dark' :
                                    'status-yellow-dark'
                    )}>
                        {item.status || 'Non défini'}
                    </div>
                </div>

            </div>
        </>
    );
};

export default Row;
